import React from 'react';
import { Box} from "@mui/material";


const SocialMediaConvert = () => {
  const lookerStudioURL = "https://lookerstudio.google.com/embed/reporting/396a3760-e376-4ab3-8a7c-86e29d3acf20/page/LEFZE";

  return (
    <Box sx={{ width: '100%', height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <iframe
            title="Looker Studio Report"
            src={lookerStudioURL}
            width="100%"
            height="100%"
            style={{
                border: 'none',
                boxShadow: '0px 2px 5px rgba(0,0,0,0.2)',
                borderRadius: '8px'
            }}
            allowFullScreen
        ></iframe>
    </Box>
  );
};

export {SocialMediaConvert};